<div class="container">
    <shared-external-logo [tenantId]="tenantId"></shared-external-logo>
    <div *ngIf="showButtonBack" class="button back" (click)="back()"><i  class="fa fa-angle-left" aria-hidden="true"></i></div>
</div>